// Text layout for position bubbles: monospace word-wrap so text never leaves the bubble.
const CW = 0.62;
export const BUBBLE_LH = 1.15;

function wrap(text, maxChars) {
    const out = [];
    String(text ?? "").split(/\s+/).filter(Boolean).forEach((word) => {
        const parts = word.match(new RegExp(`.{1,${maxChars}}`, "g")) || [""];
        parts.forEach((p) => {
            const last = out[out.length - 1];
            if (last !== undefined && last.length + 1 + p.length <= maxChars && p === parts[0]) out[out.length - 1] = `${last} ${p}`;
            else out.push(p);
        });
    });
    return out.length ? out : [""];
}

// px = base bubble size. Width/height follow st.bw / st.bh (multipliers); height grows with text unless st.bh is set,
// in which case the font shrinks to fit.
export function bubbleBox(label, px, st) {
    const w = px * (st.bw || 1);
    const fixedH = st.bh ? px * st.bh : null;
    const round = st.shape === "circle";
    const padX = Math.max(1, w * (round ? 0.14 : 0.07));
    const padY = Math.max(1, px * 0.06);
    const BORDER = 4;
    const innerW = Math.max(2, w - 2 * padX - BORDER);
    let fs = Math.max(3, px * 0.42 * (st.fontScale || 1));
    const fs0 = fs;
    const longestWord = Math.max(1, ...String(label ?? "").split(/\s+/).map((x) => x.length));
    let lines = [String(label ?? "")];
    for (let i = 0; i < 40; i++) {
        const maxChars = Math.max(1, Math.floor(innerW / (fs * CW)));
        lines = wrap(label, maxChars);
        const longest = Math.max(...lines.map((l) => l.length)) * fs * CW;
        const fitsW = longest <= innerW + 0.5 && (fixedH || longestWord * fs * CW <= innerW + 0.5 || fs <= fs0 * 0.6);
        const fitsH = !fixedH || lines.length * fs * BUBBLE_LH <= fixedH - 2 * padY - BORDER + 0.5;
        if ((fitsW && fitsH) || fs <= 2) break;
        fs *= 0.92;
    }
    const textH = lines.length * fs * BUBBLE_LH + 2 * padY + BORDER + 1;
    const h = fixedH || Math.max(px, textH);
    return { w, h, fs, lines, padX, padY };
}
